import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataResponse } from '../../core/models/data-response';
import { ConfigService } from '../../core/services/config/config.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { PatientResult } from '../models/patient-result';

@Injectable({
  providedIn: 'root',
})
export class PatientResultService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  patientResultsEndpoint = `${this.config.patientApiUrl}/v1/PatientPortal/PatientLabResults`;

  getPatientResults(
    patientId: number,
    searchTerm: string | null,
    abnormalTypeId: number | null,
    labResultStatusTypeId: number | null,
    sortDirection: number,
    sortColumn: string,
    pageNumber: number,
    pageSize: number
  ): Observable<DataResponse<PatientResult[]>> {
    const searchParams = {
      searchTerm,
      abnormalTypeId,
      labResultStatusTypeId,
      sortDirection,
      sortColumn,
      pageNumber,
      pageSize,
    };
    return this.utilityService.postRequest<DataResponse<PatientResult[]>>(
      `${this.patientResultsEndpoint}?patientId=${patientId}`,
      searchParams,
      // The list read opts out of the global error page: ResultsComponent renders app-error-state
      // with a retry. getPatientResultsbyId is deliberately left on the global path - the detail
      // screen has no error state of its own yet.
      { rawResponse: true, skipGlobalError: true, applyDefaultTimeout: true }
    );
  }

  getPatientResultsbyId(patientLabResultId: number, patientId: number): Observable<PatientResult> {
    const url = `${this.patientResultsEndpoint}/${patientLabResultId}?patientId=${patientId}`;
    return this.utilityService.getRequest<PatientResult>(url);
  }

  markAllAsRead(patientLabResultIds: number[], patientId: number): Observable<number[]> {
    const url = this.patientResultsEndpoint + '/MarkAllAsRead?patientId=' + patientId;
    const request = {
      patientLabResultIds,
    };
    return this.utilityService.putRequest<number[]>(url, request, { skipGlobalError: true });
  }
}
